import { string } from 'yup';

export const MENSAGEM_COR_INVALIDA = 'Cor inválida. Informe um hexadecimal no formato #RRGGBB.';

export const corValida = (cor) => /^#[0-9A-F]{6}$/.test(cor ?? '');

// O ColorPicker do PrimeVue trabalha sem o # e em minúsculo; a API espera #RRGGBB.
export const normalizarCor = (valor) => {
    const cor = (valor ?? '').trim().toUpperCase();

    return /^[0-9A-F]{6}$/.test(cor) ? `#${cor}` : cor;
};

// Regra de validação do CorCampo, para compor o schema do useForm na view pai:
// cor: regraCor()
export const regraCor = () =>
    string().nullable().test('cor-valida', MENSAGEM_COR_INVALIDA, (valor) => !valor || corValida(valor));
